import React from 'react';
import { ToolbarProps } from 'react-big-calendar';

import { ICalendarAuthAccount } from 'APP/model/calendar/calendar.types';

import { IEventCalendar } from '../Content.types';
import { CompactToolbar } from './Views/CompactToolbarView';
import { Toolbar } from './Views/ToolbarView';

export interface IToolbarProps {
  onCreate(): void;
  accounts: ICalendarAuthAccount[];
  isCompact?: boolean;
}

export const makeToolbar = (props: IToolbarProps): React.FC<ToolbarProps<IEventCalendar>> => {
  const component: React.FC<ToolbarProps<IEventCalendar>> = (innerProps) => {
    if (props.isCompact) {
      return (
        <CompactToolbar
          {...innerProps}
          {...props}
        />
      );
    }

    return (
      <Toolbar
        {...innerProps}
        {...props}
      />
    );
  };

  return component;
};
